import t from "./_common.js";
function e() {
  return t;
}
const o = {
  name: "Space",
  self: e
}, c = o;
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/space/styles/light.js
// module id = 1741
// module chunks = 67